export default __webpack_public_path__ + "static/media/coloquio_BannerWeb_movil_5.ac0a1c94.jpg";